module.exports = __webpack_public_path__ + "static/img/qnset4.136e979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset4.png
// module id = 358
// module chunks = 0